import acrobats from '@wwe-portal/ui/assets/images/roster/class/acrobats.webp';
import powerhouses from '@wwe-portal/ui/assets/images/roster/class/powerhouses.webp';
import showboats from '@wwe-portal/ui/assets/images/roster/class/showboats.webp';
import strikers from '@wwe-portal/ui/assets/images/roster/class/strikers.webp';
import technicians from '@wwe-portal/ui/assets/images/roster/class/technicians.webp';
import tricksters from '@wwe-portal/ui/assets/images/roster/class/tricksters.webp';
import { mapArrayToRecord } from '@wwe-portal/utils/array';

export const rosterClasses = [
  { id: 'Showboats', title: 'showboats', iconUrl: showboats },
  { id: 'Acrobats', title: 'acrobats', iconUrl: acrobats },
  { id: 'Powerhouses', title: 'powerhouses', iconUrl: powerhouses },
  { id: 'Technicians', title: 'technicians', iconUrl: technicians },
  { id: 'Tricksters', title: 'tricksters', iconUrl: tricksters },
  { id: 'Strikers', title: 'strikers', iconUrl: strikers },
];

export const rosterClassColors = [
  { id: 'Yellow', title: 'showboats', iconUrl: showboats },
  { id: 'Blue', title: 'acrobats', iconUrl: acrobats },
  { id: 'Red', title: 'powerhouses', iconUrl: powerhouses },
  { id: 'Green', title: 'technicians', iconUrl: technicians },
  { id: 'Purple', title: 'tricksters', iconUrl: tricksters },
  { id: 'Black', title: 'strikers', iconUrl: strikers },
];

export const rosterClassesMap = mapArrayToRecord(
  rosterClasses,
  (item) => item.id
);
